import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { Action } from "rxjs/internal/scheduler/Action";
import { UrlsConfig } from "src/app/config/urls.prod.config";
import { Question, Questionnaire } from "src/app/store/models/open/questionnaire.model";

@Injectable({
	providedIn: "root",
})
export class QuestionnaireService {
	SERVER_URL: string = UrlsConfig.API_ENDPOINT;

	constructor(private httpClient: HttpClient) {}

	getQuestionnaire(hash): Observable<Questionnaire> {
		
		return this.httpClient.get(UrlsConfig.API_ENDPOINT + "open/questionnaire/" + hash, {
			//headers: { storeRequest: "false" },
		});
	}

	updateReponse(action): Observable<Questionnaire> {
		// console.log("QUESTIONNAIRE", action);

		action.questionnaire.pages.forEach((p, pix) => {
			p.questions.forEach((q, qix) => {
				
				if (q.type == "DATE") {
					if (q.repondu.length>0 && q.repondu[0].reponse != null) {
						action.questionnaire.pages[pix].questions[qix].repondu[0].reponse =
							q.repondu[0].reponse.replaceAll("-", "");
					}
				}

				if(q.type=="CLASSEMENT"){
					
					
					let tmpRepondu = [];
					let ordre = "";
					if (q.repondu.length == 0) {
						tmpRepondu.push({
							id_reponse: 0,
							reponse: null,
							saisie: null,
						});
					} else {
						q.repondu.forEach((r, i) => {
							
							ordre += r.id_reponse + ";";
								
						});
						ordre = ordre.slice(0, -1);
						tmpRepondu.push({
							id_reponse: 0,
							reponse: ordre,
							saisie: null,
						});
					}

					action.questionnaire.pages[pix].questions[qix].repondu = tmpRepondu;
				}
			});
		});

		return this.httpClient.post(
			UrlsConfig.API_ENDPOINT + "open/questionnaire/updateReponse",
			{ payload: action },
			{
				//headers: { storeRequest: "false" },
			}
		);
	}

	updateReponseCheck(action): Observable<Questionnaire> {
		// console.log(action);
		return this.httpClient.post(
			UrlsConfig.API_ENDPOINT + "open/questionnaire/updateReponseCheck",
			{ payload: action },
			{
				//headers: { storeRequest: "false" },
			}
		);
	}

	enregistreQuestionnaire(action,ip): Observable<Questionnaire> {

		action.pages.forEach((p, pix) => {
			p.questions.forEach((q, qix) => {
				
				if (q.type == "DATE") {
					if (q.repondu[0].reponse != null) {
						action.pages[pix].questions[qix].repondu[0].reponse =
							q.repondu[0].reponse.replaceAll("-", "");
					}
				}

				if(q.type=="CLASSEMENT"){
					
					
					let tmpRepondu = [];
					let ordre = "";
					if (q.repondu.length == 0) {
						tmpRepondu.push({
							id_reponse: 0,
							reponse: null,
							saisie: null,
						});
					} else {
						q.repondu.forEach((r, i) => {
							
							ordre += r.id_reponse + ";";
								
						});
						ordre = ordre.slice(0, -1);
						tmpRepondu.push({
							id_reponse: 0,
							reponse: ordre,
							saisie: null,
						});
					}

					action.pages[pix].questions[qix].repondu = tmpRepondu;
				}
			});
		});
		

		return this.httpClient.post(
			UrlsConfig.API_ENDPOINT + "open/questionnaire/enregistreQuestionnaire",
			{ payload: action,ip:ip },
			{
				//headers: { storeRequest: "false" },
			}
		);
	}

	getIp(){
		return this.httpClient.get("https://api.ipify.org/?format=json",{ headers: null });
	}

	
	enregistreQuestionnaireTemporaire(action): Observable<Questionnaire> {

		action.pages.forEach((p, pix) => {
			p.questions.forEach((q, qix) => {
				
				if (q.type == "DATE") {
					if (q.repondu[0].reponse != null) {
						action.pages[pix].questions[qix].repondu[0].reponse =
							q.repondu[0].reponse.replaceAll("-", "");
					}
				}

				if(q.type=="CLASSEMENT"){
					
					
					let tmpRepondu = [];
					let ordre = "";
					if (q.repondu.length == 0) {
						tmpRepondu.push({
							id_reponse: 0,
							reponse: null,
							saisie: null,
						});
					} else {
						q.repondu.forEach((r, i) => {
							
							ordre += r.id_reponse + ";";
								
						});
						ordre = ordre.slice(0, -1);
						tmpRepondu.push({
							id_reponse: 0,
							reponse: ordre,
							saisie: null,
						});
					}

					action.pages[pix].questions[qix].repondu = tmpRepondu;
				}
			});
		});

		return this.httpClient.post(
			UrlsConfig.API_ENDPOINT + "open/questionnaire/enregistreQuestionnaireTemporaire",
			{ payload: action },
			{
				//headers: { storeRequest: "false" },
			}
		);
	}

	insertReponse() {}

	deleteReponse() {}
}
